/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WorkspacesInputs */

const en_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspaces`)
};

const fr_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaces de travail`)
};

const de_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsbereiche`)
};

const it_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazi di lavoro`)
};

const ru_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочие места`)
};

const es_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacios de trabajo`)
};

const zh_cn2_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作区`)
};

const ja_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワークスペース`)
};

const hi_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यस्थानों`)
};

const pt_pt2_workspaces = /** @type {(inputs: WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaços de trabalho`)
};

/**
* | output |
* | --- |
* | "Workspaces" |
*
* @param {WorkspacesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspaces = /** @type {((inputs?: WorkspacesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WorkspacesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_workspaces(inputs)
	if (locale === "de") return de_workspaces(inputs)
	if (locale === "it") return it_workspaces(inputs)
	if (locale === "ru") return ru_workspaces(inputs)
	if (locale === "es") return es_workspaces(inputs)
	if (locale === "zh-CN") return zh_cn2_workspaces(inputs)
	if (locale === "ja") return ja_workspaces(inputs)
	if (locale === "hi") return hi_workspaces(inputs)
	if (locale === "pt-PT") return pt_pt2_workspaces(inputs)
	return en_workspaces(inputs)
});